import React from "react";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row, Col } from "react-bootstrap";

import "./style.css";

const PaymentExpired = () => {
  return (
    <>
      <div className="backgroundscreen">
        {/* <div className="bgcolorLogin container-fluid"> */}
        <div className="backgroundbott">
          <Container>
            <div className="cardMainlogin-suspended">
              <Row>
                <Col xs={12} md={12} sm={12} lg={12}>
                  <Container>
                    <div className="loginheaderfrst">
                      <div className="loginLogo">
                        <div>
                          <img
                            alt="logo1"
                            className="logo1-suspended"
                            src={require("../../assets/img/logo-sh.png")}
                          />
                        </div>
                        <div className="vl"></div>
                        <div>
                          <img
                            alt="logo2"
                            className="wateronlogo"
                            src={require("../../assets/img/waterOn_logo.png")}
                          />
                        </div>
                      </div>
                      <div className="suspend-logo-cont">
                        <div>
                          <img
                            alt="logo2"
                            className="no-payment-img"
                            src={require("../../assets/img/no-payment.png")}
                          />
                        </div>
                      </div>

                      <div className="suspend-msg-cont">
                        <h2 className="suspended-title">
                          Payment Session Expired
                        </h2>
                        <p className="suspend-msg1">
                          Sorry, Your session has expired. Please refer your
                          latest mail for payment Kindly ignore if already paid
                        </p>

                        <button
                          className="contactpagebtn-payment"
                          type="submit"
                        >
                          Okey
                        </button>
                        <Link to="/login" className="support-btn-payment">
                          Talk to suport
                        </Link>
                      </div>
                    </div>
                  </Container>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        {/* </div> */}
        <div className="footerclass">
          <div>
            <span className="footerSpan">
              <i className="fa fa-phone"></i> +91-777-780-4646
            </span>
            <span>
              <i className="fa fa-at"></i> info@smarterhomes.com
            </span>
          </div>
          <div>
            <span>Version 5.5.6© 2023 SmarterHomes Technologies</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default PaymentExpired;
